import { ParsedDirectLinkURL } from 'src/pages/Compliance/types';

export const transformDirectLinkParamsToVerifyPolicyInput = (
  searchParams: Record<string, string>,
) => {
  const keys: (keyof ParsedDirectLinkURL)[] = [
    'firstName',
    'lastName',
    'email',
    'buildingId',
    'buildingUnit',
    'leaseStart',
    'leaseEnd',
  ];

  return keys.reduce<ParsedDirectLinkURL>((acc: ParsedDirectLinkURL, key) => {
    if (typeof searchParams[key] === 'string') {
      acc[key] = searchParams[key] as string;
    }
    return acc;
  }, {} as ParsedDirectLinkURL);
};
